import React, { useState } from "react";
import { SetupDataPageTemplate } from "../../../components/setup-pages/SetupDataPageTemplate";
import { Field, Form } from "react-jsonschema-form-validation";
import { setupData } from "../../../configs/routes";
import {
	resetUserSettings,
	saveYourControl,
	getAppSettings,
} from "../../../services/userService";
import { schema } from "../YourControl";
import { FaExclamationTriangle } from "react-icons/fa";

import { pathRoot } from "../YourControl";

export function Page3({ yourControlSettings, handleSaveFailure, ...props }) {
	const [symptomsFrequency, setSymptomsFrequency] = useState(
		yourControlSettings.symptomsFrequency || "weeks4"
	);
	const [sideEffectsFrequency, setSideEffectsFrequency] = useState(
		yourControlSettings.sideEffectsFrequency || "weeks4"
	);
	const [prehab, setPrehab] = useState(yourControlSettings.inPrehabProgramme);

	const onNext = () => {
		yourControlSettings.symptomsFrequency = symptomsFrequency;
		yourControlSettings.sideEffectsFrequency = sideEffectsFrequency;
		yourControlSettings.inPrehabProgramme = prehab;

		return new Promise((resolve, reject) => {
			yourControlSettings.complete = true;

			saveYourControl(yourControlSettings)
				.then(resolve)
				.catch((error) => handleSaveFailure(error));
		});
	};

	const hideNext = () => {
		return false;
	};

	const headerDetails = {
		title: "Your Control",
		currentPage: 3,
		pageCount: 3,
	};

	const disableSideEffects = getAppSettings().disableSideEffects;

	const updateSideEffectsFrequency = (value) => {
		if (disableSideEffects) {
			return;
		}

		setSideEffectsFrequency(value);
	};

	return (
		<>
			<SetupDataPageTemplate
				headerDetails={headerDetails}
				backTo={`${pathRoot}/2`}
				nextTo={setupData}
				onClickBack={resetUserSettings}
				onClickNext={{ async: true, func: onNext }}
				nextTextOverride={"Finish"}
				hideNext={hideNext()}
			>
				<Form schema={schema}>
					<h2 className={"text-lg sm:text-xl font-bold mb-1 sm:mb-4"}>
						Do you wish to complete your Symptoms reports weekly or every 4
						weeks?
					</h2>

					<div className={"w-56"}>
						<div className={`radioSlider`}>
							<Field
								type="radio"
								name="symptoms"
								id="symptoms4"
								className={"hidden radioOption"}
								value={"weeks4"}
								checked={symptomsFrequency === "weeks4"}
								onClick={() => setSymptomsFrequency("weeks4")}
							/>
							<label
								htmlFor={"symptoms4"}
								className={`option ${
									symptomsFrequency === "weeks4"
										? `bg-black text-white font-medium`
										: "bg-gray-100"
								}`}
							>
								4 weeks
							</label>

							<Field
								type="radio"
								name="symptoms"
								id="symptoms1"
								className={"hidden radioOption"}
								value={"weeks1"}
								checked={symptomsFrequency === "weeks1"}
								onClick={() => setSymptomsFrequency("weeks1")}
							/>
							<label
								htmlFor={"symptoms1"}
								className={`option ${
									symptomsFrequency === "weeks1"
										? `bg-black text-white font-medium`
										: "bg-gray-100"
								}`}
							>
								Weekly
							</label>
						</div>
					</div>

					<h2 className={"text-lg sm:text-xl font-bold mb-1 sm:mb-4  mt-8"}>
						How often do you wish to record your side effects?
					</h2>

					{disableSideEffects && (
						<h3 className={"text-md text-black mb-1 sm:mb-4"}>
							<FaExclamationTriangle className="text-amber-600 text-3xl mr-2 inline" />

							{disableSideEffects === true
								? "This functionality will be available shortly."
								: disableSideEffects}
						</h3>
					)}

					<div className={"w-full flex"}>
						<div className={`radioSlider inline-block mr-1`}>
							<Field
								type="radio"
								name="sideEffects"
								id="sf0"
								className={"hidden radioOption"}
								value={"weeks0"}
								checked={sideEffectsFrequency === "weeks0"}
								onClick={() => updateSideEffectsFrequency("weeks0")}
							/>
							<label
								htmlFor={"sf0"}
								className={`option ${
									disableSideEffects
										? `bg-gray-50 text-gray-600 cursor-default`
										: sideEffectsFrequency === "weeks0"
										? `bg-black text-white font-medium`
										: "bg-gray-100"
								}`}
							>
								Never
							</label>
						</div>

						<div className={`radioSlider inline-block mx-1`}>
							<Field
								type="radio"
								name="sideEffects"
								id="sf1"
								className={"hidden radioOption"}
								value={"weeks1"}
								checked={sideEffectsFrequency === "weeks1"}
								onClick={() => updateSideEffectsFrequency("weeks1")}
							/>
							<label
								htmlFor={"sf1"}
								className={`option ${
									disableSideEffects
										? `bg-gray-50 text-gray-600 cursor-default`
										: sideEffectsFrequency === "weeks1"
										? `bg-black text-white font-medium`
										: "bg-gray-100"
								}`}
							>
								Weekly
							</label>
						</div>

						<div className={`radioSlider inline-block mx-1`}>
							<Field
								type="radio"
								name="sideEffects"
								id="sf2"
								className={"hidden radioOption"}
								value={"weeks2"}
								checked={sideEffectsFrequency === "weeks2"}
								onClick={() => updateSideEffectsFrequency("weeks2")}
							/>
							<label
								htmlFor={"sf2"}
								className={`option ${
									disableSideEffects
										? `bg-gray-50 text-gray-600 cursor-default`
										: sideEffectsFrequency === "weeks2"
										? `bg-black text-white font-medium`
										: "bg-gray-100"
								}`}
							>
								2 weeks
							</label>
						</div>

						<div className={`radioSlider inline-block ml-1`}>
							<Field
								type="radio"
								name="sideEffects"
								id="sf4"
								className={"hidden radioOption"}
								value={"weeks4"}
								checked={sideEffectsFrequency === "weeks4"}
								onClick={() => updateSideEffectsFrequency("weeks4")}
							/>
							<label
								htmlFor={"sf4"}
								className={`option ${
									disableSideEffects
										? `bg-gray-50 text-gray-600 cursor-default`
										: sideEffectsFrequency === "weeks4"
										? `bg-black text-white font-medium`
										: "bg-gray-100"
								}`}
							>
								4 weeks
							</label>
						</div>
					</div>

					<h2 className={"text-lg sm:text-xl font-bold mb-1 sm:mb-4 mt-8"}>
						Are you currently part of a pre-hab programme?
					</h2>

					<div className={"flex"}>
						<div className={"flex-grow"}>
							<p
								className={
									"mb-4 text-sm lg:text-base leading-tight lg:leading-6 pr-2"
								}
							>
								Selecting "Yes" will allow you to complete a weekly Pre-hab
								questionnaire.
								<br />
								When you no longer wish to complete it, simply re-select "No".
							</p>
						</div>
					</div>

					<div className={"w-56"}>
						<div className={`radioSlider`}>
							<Field
								type="radio"
								name="prehab"
								id="prehabno"
								className={"hidden radioOption"}
								value={"prehabno"}
								checked={!prehab}
								onClick={() => setPrehab(false)}
							/>
							<label
								htmlFor={"prehabno"}
								className={`option ${
									!prehab ? `bg-black text-white font-medium` : "bg-gray-100"
								}`}
							>
								No
							</label>

							<Field
								type="radio"
								name="prehab"
								id="prehabyes"
								className={"hidden radioOption"}
								value={"prehabyes"}
								checked={prehab}
								onClick={() => setPrehab(true)}
							/>
							<label
								htmlFor={"prehabyes"}
								className={`option ${
									prehab ? `bg-black text-white font-medium` : "bg-gray-100"
								}`}
							>
								Yes
							</label>
						</div>
					</div>
				</Form>
			</SetupDataPageTemplate>
		</>
	);
}
